<script setup lang="ts">
definePageMeta({
    layout: 'admin'
});
import LButton from '~/components/lbutton.vue';
import LInput from '~/components/linput.vue';
import LPanel from '~/components/lpanel.vue';
import { useFirebaseAuth } from '~/composables/useFirebaseAuth';

const { login, isLoggedIn, user, loading } = useFirebaseAuth();
const email = ref('');
const password = ref('');
const error = ref('');



const loginSubmit = async () => {
    try {
        error.value = '';
        const user = await login(email.value, password.value);
        console.log('user', user);
        navigateTo('/admin');
    } catch (e) {
        error.value = 'Feil brukernavn eller passord';
    }
}
</script>
<template>
    <div class="w-md mx-auto mt-10">
        <LPanel>
            <div v-if="loading" class="text-center">
                <p>Laster...</p>
            </div>
            <div v-else-if="isLoggedIn">
                <p>Du er logget inn som {{ user?.email }}</p>
            </div>
            <div v-else class="space-y-4">
                <form @submit.prevent="loginSubmit">
                    <LInput label="E-post" v-model="email" type="text" />
                    <LInput label="Passord" v-model="password" type="password" />
                    <div v-if="error" class="text-red-500 text-sm mt-2">{{ error }}</div>
                    <div class="flex justify-center mt-4">
                        <LButton text="Logg inn" />
                    </div>
                </form>
            </div>
        </LPanel>
    </div>
</template>
